<template>
<div>
    <h3>One Column Layout</h3>
    <div class="ft-one-col-grid-container">
  <div class="column-bk ft-one-col-col1">Column 1</div>
  </div>
  <!--
    <div class="ft-grid-container">
    <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
    </div> -->
    <h4>Code:</h4>
     <pre><code>&lt;div class=&quot;ft-one-col-grid-container&quot;&gt;
  &lt;div class=&quot;ft-one-col-col1&quot;&gt;Column 1&lt;/div&gt;
&lt;/div&gt;</code></pre>
<hr>
<h3>Two Column Layout</h3>
<div class="ft-two-col-grid-container">
  <div class="column-bk ft-two-col-col1">Column 1</div>
  <div class="column-bk ft-two-col-col2">Column 2</div>
</div>
<!--   
<div class="ft-grid-container">
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 2
        </div>
    </div>
</div> -->
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-two-col-grid-container&quot;&gt;
  &lt;div class=&quot;ft-two-col-col1&quot;&gt;Column 1&lt;/div&gt;
  &lt;div class=&quot;ft-two-col-col2&quot;&gt;Column 2&lt;/div&gt;
&lt;/div&gt;
</code></pre> 
<hr>
 <h3>Three Column Layout</h3>
 <div class="ft-three-col-grid-container">
  <div class="column-bk ft-three-col-col1">Column 1</div>
  <div class="column-bk ft-three-col-col2">Column 2</div>
  <div class="column-bk ft-three-col-col3">Column 3</div>
</div>
 <!--
<div class="ft-grid-container">
    <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 2
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 3
        </div>
    </div>
</div>-->
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-three-col-grid-container&quot;&gt;
  &lt;div class=&quot;ft-three-col-col1&quot;&gt;Column 1&lt;/div&gt;
  &lt;div class=&quot;ft-three-col-col2&quot;&gt;Column 2&lt;/div&gt;
  &lt;div class=&quot;ft-three-col-col3&quot;&gt;Column 3&lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
 <h3>Four Column Layout</h3>
<div class="ft-four-col-grid-container">
  <div class="column-bk ft-four-col-col1">Column 1</div>
  <div class="column-bk ft-four-col-col2">Column 2</div>
  <div class="column-bk ft-four-col-col3">Column 3</div>
  <div class="column-bk ft-four-col-col4">Column 4</div>
</div>

<!--
<div class="ft-grid-container">
    <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 2
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 3
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 4
        </div>
    </div>
</div>-->
  <h4>Code:</h4>
     <pre><code>&lt;div class=&quot;ft-four-col-grid-container&quot;&gt;
  &lt;div class=&quot;ft-four-col-col1&quot;&gt;Column 1&lt;/div&gt;
  &lt;div class=&quot;ft-four-col-col2&quot;&gt;Column 2&lt;/div&gt;
  &lt;div class=&quot;ft-four-col-col3&quot;&gt;Column 3&lt;/div&gt;
  &lt;div class=&quot;ft-four-col-col4&quot;&gt;Column 4&lt;/div&gt;
&lt;/div&gt;</code></pre>
<hr>
 <h3>Five Column Layout</h3>
 <div class="ft-five-col-grid-container">
  <div class="column-bk ft-five-col-col1">Column 1</div>
  <div class="column-bk ft-five-col-col2">Column 2</div>
  <div class="column-bk ft-five-col-col3">Column 3</div>
  <div class="column-bk ft-five-col-col4">Column 4</div>
  <div class="column-bk ft-five-col-col5">Column 5</div>
</div>
 <!--
<div class="ft-grid-container">
  <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 2
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 3
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 4
        </div>
    </div>
      <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 5
        </div>
    </div>
</div>-->
<h4>Code:</h4>
<pre><code> &lt;div class=&quot;ft-five-col-grid-container&quot;&gt;
  &lt;div class=&quot;ft-five-col-col1&quot;&gt;Column 1&lt;/div&gt;
  &lt;div class=&quot;ft-five-col-col2&quot;&gt;Column 2&lt;/div&gt;
  &lt;div class=&quot;ft-five-col-col3&quot;&gt;Column 3&lt;/div&gt;
  &lt;div class=&quot;ft-five-col-col4&quot;&gt;Column 4&lt;/div&gt;
  &lt;div class=&quot;ft-five-col-col5&quot;&gt;Column 5&lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
 <h3>Six Column Layout</h3>

<div class="ft-six-col-grid-container">
  <div class="column-bk ft-six-col-col1">Column 1</div>
  <div class="column-bk ft-six-col-col2">Column 2</div>
  <div class="column-bk ft-six-col-col3">Column 3</div>
  <div class="column-bk ft-six-col-col4">Column 4</div>
  <div class="column-bk ft-six-col-col5">Column 5</div>
  <div class="column-bk ft-six-col-col6">Column 6</div>
</div>

 <!--
<div class="ft-grid-container">
  <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 2
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 3
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 4
        </div>
    </div>
      <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 5
        </div>
    </div>
     <div class="column-bk ft-grid-item">
        <div class="ft-template-column">
        Column 6
        </div>
    </div>
</div>-->

<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-six-col-grid-container&quot;&gt;
  &lt;div class=&quot;column-bk ft-six-col-col1&quot;&gt;Column 1&lt;/div&gt;
  &lt;div class=&quot;column-bk ft-six-col-col2&quot;&gt;Column 2&lt;/div&gt;
  &lt;div class=&quot;column-bk ft-six-col-col3&quot;&gt;Column 3&lt;/div&gt;
  &lt;div class=&quot;column-bk ft-six-col-col4&quot;&gt;Column 4&lt;/div&gt;
  &lt;div class=&quot;column-bk ft-six-col-col5&quot;&gt;Column 5&lt;/div&gt;
  &lt;div class=&quot;column-bk ft-six-col-col6&quot;&gt;Column 6&lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
 <h3>3/4 + 1/4 Layout</h3>
<div class="ft-grid-container-12">
    <div class="column-bk ft-col-1-9">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-col-9-13">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-grid-container-12&quot;&gt;
    &lt;div class=&quot;ft-col-1-9&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;ft-col-9-13&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
 <h3>10/12 + 2/12 Layout</h3>
<div class="ft-grid-container-12">
    <div class="column-bk ft-col-1-10">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-col-10-12">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-grid-container-12&quot;&gt;
    &lt;div class=&quot;ft-col-1-10&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;ft-col-10-12&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
<h3>1/4 + 3/4 Layout</h3>
<div class="ft-grid-container-12">
    <div class="column-bk ft-col-1-4">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-col-4-12">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-grid-container-12&quot;&gt;
    &lt;div class=&quot;ft-col-1-4&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;ft-col-4-12&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre>    
<hr>
<h3>2/12 + 10/12 Layout</h3>
<div class="ft-grid-container-12">
    <div class="column-bk ft-col-1-3">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-col-3-12">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-grid-container-12&quot;&gt;
    &lt;div class=&quot;ft-col-1-3&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;ft-col-3-12&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre>    

<hr>
<h3>3/12 + 9/12 Layout</h3>
<div class="ft-grid-container-12">
    <div class="column-bk ft-12col-1-4">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-12col-4-12">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-grid-container-12&quot;&gt;
    &lt;div class=&quot;ft-col-1-4&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;ft-col-9-12&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre> 


<hr>
<h3>200px + 1fr Layout</h3>
<div class="ft-fixed200-col-grid-container">
    <div class="column-bk ft-fixed200-col1">
        <div class="ft-template-column">
        Column 1
        </div>
    </div>
     <div class="column-bk ft-fixed200-col2">
         <div class="ft-template-column">
        Column 2
         </div>
    </div>
</div>
<h4>Code:</h4>
<pre><code>&lt;div class=&quot;ft-fixed200-col-grid-container&quot;&gt;
    &lt;div class=&quot;column-bk ft-fixed200-col1&quot;&gt;
        &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 1
        &lt;/div&gt;
    &lt;/div&gt;
     &lt;div class=&quot;column-bk ft-fixed200-col1&quot;&gt;
         &lt;div class=&quot;ft-template-column&quot;&gt;
        Column 2
         &lt;/div&gt;
    &lt;/div&gt;
&lt;/div&gt;
</code></pre> 
<!-- Test Area -->



</div>
</template>
<script>
export default{
  name: 'fourcolgridcomp',
  data () {
    return {
      title: 'fourcolgridcomp'
    }
  }
}
</script>

<style scoped src="../assets/marketing-layout.css"></style>

<style scoped>

/* Generic Classes for Demo */
.column-bk {
    background-color: #f4f4f4;
    width: 100%;
    min-height: 150px;
    text-align: center;
    padding-top: 10px;
}

hr {
    margin: 30px 0 30px 0;
}

pre {
    padding: 10px;
    background-color: #001628;
    color: #f4f4f4;
    font-family: Consolas, "Andale Mono WT", "Andale Mono", "Lucida Console", "Lucida Sans Typewriter", "DejaVu Sans Mono", "Bitstream Vera Sans Mono", "Liberation Mono", "Nimbus Mono L", Monaco, "Courier New", Courier, monospace;
     overflow-x: auto;
            white-space: pre-wrap;
            white-space: -moz-pre-wrap;
            white-space: -pre-wrap;
            white-space: -o-pre-wrap;
            word-wrap: break-word;
}

</style>
